import React, { Component, Fragment } from "react";
// import Button from "../../components/Button/Button";
// import map_1 from "../../assets/preLoginUi/map_1.png";

class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      full_name: "",
      email_address: "",
      your_message: "",
    };
  }

  componentDidMount() {
    const script = document.createElement('script');
    script.src = 'https://js-eu1.hsforms.net/forms/embed/v2.js';
    document.body.appendChild(script);

    script.addEventListener('load', () => {
        if (window.hbspt) {
            window.hbspt.forms.create({
                target: '#hubspotForm',
                region: "eu1",
                portalId: "25065632",
                formId: "99c98a45-7eb2-4f34-9649-d178c51fcaca"
            })
            this.setState({ fetching: false })
        }
    });
}

  render() {
    // const { full_name, email_address, your_message } = this.state;
    return (
      <Fragment>
        <div className="card al_card_5">
          <div className="card-body">
            <p className="text-center text_font_9 mt-5">Contact</p>
            <div className="row justify-content-center">
              <div className="col-md-7">
                <p className="h5 mt-4">Leave us a message</p>

                <div className="row mt-4">
                  <div className="col-12">

                  <div id="hubspotForm"></div>
                    {/* <input
                      className="form-control"
                      type="string"
                      name="full_name"
                      placeholder="Your name"
                      value={full_name}
                      onChange={(e) =>
                        this.setState({
                          full_name: e.target.value,
                        })
                      }
                    /> */}
                  </div>
                </div>
                {/* <div className="row mt-3">
                  <div className="col-12">
                    <input
                      className="form-control"
                      type="string"
                      name="email_address"
                      placeholder="Email Address"
                      value={email_address}
                      onChange={(e) =>
                        this.setState({
                          email_address: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-12">
                    <input
                      className="form-control p_bottom"
                      type="string"
                      name="your_message"
                      placeholder="Your Message"
                      value={your_message}
                      onChange={(e) =>
                        this.setState({
                          your_message: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col">
                    <Button
                      type="button"
                      size="lg"
                      text="Send"
                      customClass={"col-12 al_button_new"}
                    />
                  </div>
                </div> */}
                <div className="row justify-content-center">
                  <div className="col-12 col-md-6 mb-3">
                  <a className="mb-2" href={"mailto:support@pulselabs.co.in"} alt={''} target="_blank">
                      <i class="fa fa-envelope-o fa-lg" aria-hidden="true"></i>
                    </a>
                  <a className="mb-2" href={"https://www.linkedin.com/in/pulse-labs-8b639aba/"} alt={''} target="_blank">
                      <i class="fa fa-linkedin-square fa-lg ml-4 my-3" aria-hidden="true"></i>
                    </a>
                    <a className="mb-2" href={'https://www.facebook.com/pulselabsresearch/'} alt={''} target="_blank">
                      <i class="fa fa-facebook fa-lg ml-4 my-3" aria-hidden="true"></i>
                    </a>
                    <a className="mb-2" href={'https://twitter.com/pulselabs7 '} alt={''} target="_blank">
                      <i class="fa fa-twitter fa-lg ml-4" aria-hidden="true"></i>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-md-6 mt-4">
                {/* <div className="row">
                  <div className="col-md-12 d-flex flex-row align-self-end">
                    <span className="mr-3 mt-1">
                      <i class="fa fa-map-marker fa-lg" aria-hidden="true"></i>
                    </span>
                    <div className="d-flex flex-column">
                      <span className="text_53 text-dark">
                        Infomation technologies building, Yogyakarta , Jawa tengah
                      </span>
                    </div>
                  </div>
                </div> */}
                {/* <div className="row mt-2">
                  <div className="col-md-12 mb-3">
                    <i class="fa fa-phone fa-lg" aria-hidden="true"></i>
                    <span className="text_53 text-dark ml-3">+91 9686218778</span>
                  </div>
                </div> */}
                {/* <div className="row mt-2">
                  <div className="col-md-12 mb-3">
                    <i class="fa fa-envelope-o fa-lg" aria-hidden="true"></i>
                    <a className="text_53 text-dark ml-3"
                      href={"mailto:support@pulselabs.co.in"} target="_blank">support@pulselabs.co.in </a>
                  </div>
                </div> */}
              
                {/* <div className="row mt-2">
                  <div className="col-md-12 mb-3">
                    <img src={map_1} alt="images" className="" width={"90%"} />
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default Contact;
